/* Surgix native quote basket. No credentials, third-party services or cart requests. */
(() => {
 'use strict';
 const dialog = document.getElementById('SurgixQuote');
 if (!dialog || window.surgixQuoteReady) return;
 window.surgixQuoteReady = true;
 const key = 'surgix.quote.v1', pendingKey = 'surgix.quote.pending.v1';
 const form = document.getElementById('SurgixQuoteForm');
 const itemsNode = dialog.querySelector('[data-sq-items]');
 const notice = dialog.querySelector('[data-sq-notice]');
 let basket = [], storageOK = true;
 const quantity = n => Math.min(99999, Math.max(1, Math.floor(Number(n) || 1)));
 const safeURL = (value, image = false) => {
  try { const u = new URL(value, location.origin); return (u.protocol === 'https:' || u.protocol === 'http:') && (image || u.origin === location.origin) ? u.href : ''; } catch { return ''; }
 };
 function read(value) {
  try {
   const data = JSON.parse(value || '[]');
   if (!Array.isArray(data)) return [];
   const seen = new Set();
   return data.filter(x => x && /^\d+$/.test(String(x.id)) && typeof x.title === 'string' && !seen.has(String(x.id)) && seen.add(String(x.id))).slice(0,100).map(x => ({id:String(x.id),title:x.title.slice(0,300),variant:String(x.variant || '').slice(0,300),sku:String(x.sku || '').slice(0,150),url:safeURL(x.url),image:x.image ? safeURL(x.image,true) : '',qty:quantity(x.qty)}));
  } catch { return []; }
 }
 try { basket = read(localStorage.getItem(key)); } catch { storageOK = false; }
 function persist() {
  try { localStorage.setItem(key,JSON.stringify(basket)); } catch { storageOK = false; }
  if (!storageOK) notice.textContent = 'Browser storage is unavailable. Your basket will last only while this page stays open.';
 }
 function node(tag,text,cls) { const n=document.createElement(tag); if (text !== undefined) n.textContent=text; if(cls)n.className=cls; return n; }
 function render() {
  itemsNode.replaceChildren();
  document.querySelectorAll('[data-sq-count]').forEach(n => n.textContent = basket.length);
  if (!basket.length) itemsNode.append(node('p','Your quote basket is empty. Add instruments to get started.'));
  basket.forEach(item => {
   const row=node('div',undefined,'sq-item');
   const media=node('div');
   if(item.image){const img=node('img');img.src=item.image;img.alt='';img.width=64;img.height=64;img.loading='lazy';media.append(img);}
   const info=node('div'),heading=node('h3');
   if(item.url){const a=node('a',item.title);a.href=item.url;heading.append(a);}else heading.textContent=item.title;
   info.append(heading);
   if(item.variant)info.append(node('p',item.variant));
   info.append(node('p','Surgix SKU: '+(item.sku || 'Not assigned')));
   const controls=node('div',undefined,'sq-item-controls'),label=node('label','Qty'),input=node('input');
   input.type='number';input.min='1';input.max='99999';input.step='1';input.value=item.qty;input.dataset.sqQty=item.id;input.setAttribute('aria-label','Quantity for '+item.title);
   label.append(input);controls.append(label);
   const remove=node('button','Remove','sq-remove');remove.type='button';remove.dataset.sqRemove=item.id;remove.setAttribute('aria-label','Remove '+item.title);controls.append(remove);info.append(controls);row.append(media,info);itemsNode.append(row);
  });
  dialog.querySelector('[data-sq-submit]').disabled = !basket.length;
 }
 function open() {
  if(dialog.dataset.isBasket !== 'true') location.assign(dialog.dataset.basketUrl);
 }
 document.addEventListener('click',e=>{
  const trigger=e.target.closest('[data-sq-open]');if(trigger){e.preventDefault();open(trigger);return;}
  const add=e.target.closest('[data-sq-add]');if(!add)return;
  e.preventDefault();
  const product=add.closest('[data-sq-product]'),select=product.querySelector('[data-sq-variant]');
  const variant=select.tagName==='SELECT'?select.selectedOptions[0]:select;
  if(!variant || !/^\d+$/.test(variant.value)){notice.textContent='Please choose an instrument option.';open(add);return;}
  const existing=basket.find(x=>x.id===variant.value);
  if(existing)existing.qty=quantity(existing.qty+1);
  else {
   if(basket.length>=100){notice.textContent='A request can contain up to 100 different instruments. Please submit this request before starting another.';open(add);return;}
   basket.push({id:variant.value,title:product.dataset.title,variant:select.tagName==='SELECT'?variant.textContent.trim():'',sku:variant.dataset.sku||'',image:variant.dataset.image||'',url:safeURL(product.dataset.url+'?variant='+variant.value),qty:1});
  }
  const success=dialog.querySelector('[data-sq-success]');if(success)success.hidden=true;
  notice.textContent='Added '+product.dataset.title+' to your quote.';
  document.querySelector('[data-sq-announcement]').textContent=notice.textContent;
  persist();render();
  add.dataset.sqLabel ||= add.textContent;add.textContent='Added to quote ✓';
  clearTimeout(add.sqFeedbackTimer);
  add.sqFeedbackTimer=setTimeout(()=>{if(add.isConnected)add.textContent=add.dataset.sqLabel;},1500);
 });
 itemsNode.addEventListener('change',e=>{
  if(!e.target.matches('[data-sq-qty]'))return;
  const item=basket.find(x=>x.id===e.target.dataset.sqQty);if(item){item.qty=quantity(e.target.value);e.target.value=item.qty;persist();}
 });
 itemsNode.addEventListener('click',e=>{
  const button=e.target.closest('[data-sq-remove]');if(!button)return;
  const index=basket.findIndex(x=>x.id===button.dataset.sqRemove);basket=basket.filter(x=>x.id!==button.dataset.sqRemove);persist();render();
  const buttons=itemsNode.querySelectorAll('[data-sq-remove]');(buttons[Math.min(index,buttons.length-1)]||dialog.querySelector('[data-sq-submit]')).focus();
  notice.textContent='Instrument removed.';
 });
 form.addEventListener('submit',e=>{
  if(!basket.length){e.preventDefault();if(!basket.length)notice.textContent='Add at least one instrument before submitting.';return;}
  if(!form.reportValidity()){e.preventDefault();return;}
  // Snapshot the submitted basket; clear only these quantities after Shopify confirms success.
  const snapshot=basket.map(x=>({...x}));
  form.querySelector('[data-sq-body]').value='SURGIX QUOTE REQUEST\n\n'+snapshot.map((x,i)=>`${i+1}. ${x.title}\nOption: ${x.variant||'Default'}\nSurgix SKU: ${x.sku||'Not assigned'}\nVariant ID: ${x.id}\nQuantity: ${x.qty}\nProduct: ${x.url}`).join('\n\n')+'\n\nRequirements:\n'+form.querySelector('[data-sq-message]').value;
  try {sessionStorage.setItem(pendingKey,JSON.stringify({items:snapshot,time:Date.now()}));}catch{}
  // Allow Shopify's ordinary POST and spam protection to run.

 });
 let pending=null;
 try {pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');}catch{}
 const recent=pending&&Date.now()-pending.time<3600000;
 if(dialog.querySelector('[data-sq-success]') && recent){
  const sent=read(JSON.stringify(pending.items));
  basket=basket.flatMap(x=>{const old=sent.find(s=>s.id===x.id);return !old?[x]:x.qty>old.qty?[{...x,qty:x.qty-old.qty}]:[];});
  persist();try{sessionStorage.removeItem(pendingKey);}catch{}open();
} else if(dialog.querySelector('[data-sq-success]')) dialog.querySelector('[data-sq-success]').hidden=true;
if(dialog.querySelector('[data-sq-errors]')&&recent)open();
if(location.hash==='#SurgixQuoteForm')open();
 window.addEventListener('storage',e=>{if(e.key===key){basket=read(e.newValue);render();}});
 window.addEventListener('pageshow',render);
 render();if(!storageOK)notice.textContent='Browser storage is unavailable. Your basket will last only while this page stays open.';
})();
